import api from '../../api/vo2api'


import BaseEntity from './BaseEntity';
import phaseTypes from "../../lib/PhaseTypes";
import protocolTypes from "../../lib/ProtocolTypes"

let baseEntity = new BaseEntity({

    getEntityType() {
        return 'session';
    },

    getEmptyName() {
        return '(empty name)'
    },

    getById(orgId, id) {
        return api.getSession(orgId, id)
    },

    deleteById(orgId, entity) {
        return api.deleteSession(orgId, entity)
    },

    getItems(orgId, athleteId, rangeLimit) {
        return api.getSessionList(orgId, athleteId, rangeLimit)
    },

    getEntityId(entity) {
        if(entity) {
            return entity.sessionId;
        }
        return null
    },

    insertOrUpdate(orgId, entity) {
        return api.insertOrUpdateSession(orgId, entity);
    },

    augmentEntity( base, entity ) {

        if(entity) {
            entity.sanitizedName = base.normalizeEntityName(entity.sessionId, entity, this.getEmptyName())

            entity.athleteWeight = (entity.athleteWeight ? Math.max(entity.athleteWeight, 0) : 0)
            entity.athleteHeight = (entity.athleteHeight ? Math.max(entity.athleteHeight, 0) : 0)

            //start time
            if(entity.startTimeValid !== undefined) {

                if(entity.startTimeValid && entity.startTime) {
                    entity.startTimeObject = base.parseDate(entity.startTime);
                } else {
                    entity.startTimeObject = null;
                }

            } else if(entity.startTime){
                entity.startTimeObject = base.parseDate(entity.startTime);
            }

            //end time
            if(entity.endTimeValid !== undefined) {

                if(entity.endTimeValid && entity.endTime) {
                    entity.endTimeObject = base.parseDate(entity.endTime);
                } else {
                    entity.endTimeObject = null;
                }

            } else if(entity.endTime) {
                entity.endTimeObject = base.parseDate(entity.endTime);
            }

            let state = entity.state.toLowerCase();
            entity.isComplete = (state === 'complete');

            entity.venturiSize = entity.vO2VenturiSize ?? entity.vo2VenturiSize ?? '-';
            entity.maskSize = entity.vO2MaskSize ?? entity.vo2MaskSize ?? '-';
            entity.volumeCorrectionMode = (entity.vO2VolumeCorrectionMode ?? entity.vo2VolumeCorrectionMode ??'-').toUpperCase();

            if(entity.protocolPlan) {
                let protocolType = entity.protocolPlan.type;

                let protocol = protocolTypes.find(protocolType);
                entity.protocolPlan.typeName = protocol.label;

                entity.protocolType = protocolType;
                entity.protocolTypeName = entity.protocolPlan.typeName;

                if(entity.protocolPlan.metaFields) {

                    entity.protocolPlan.metaFields.forEach(function (field) {
                        switch(field.type) {
                            case 'rmrActivityLevel': field.name = 'Activity Level'; break;
                            case 'rmrGoalWeight': field.name = 'Goal Weight'; break;
                            case 'rmrWeightLossGoal': field.name = 'Weekly Loss Goal'; break;
                            case 'stepTestDidReachVo2Max': field.name = 'Reached maximal effort (VO2max)'; break;
                            default:
                                field.name = field.type;
                                break;
                        }
                    });
                }

                if(entity.protocolPlan.phases) {

                    entity.protocolPlan.phases.forEach(function (p) {

                        let phase = phaseTypes.find(p.phaseType);
                        p.name = phase.label;

                        if(p.settings) {
                            p.settings.forEach(function (s) {

                                switch(s.type) {
                                    case 'duration': s.name = 'Duration'; break;
                                    case 'intensity': s.name = 'Intensity'; break;
                                    case 'incline': s.name = 'Incline'; break;

                                    case 'stepStartingIntensity': s.name = 'Starting Intensity'; break;
                                    case 'stepSize': s.name = 'Step Size'; break;
                                    case 'stepDuration': s.name = 'Step Duration'; break;
                                    case 'stepInclineSize': s.name = 'Step Incline'; break;
                                    case 'stepStartingIncline': s.name = 'Starting Incline'; break;
                                    case 'stepLimit': s.name = 'Step Count'; break;


                                    case 'intervalStartingIntensity': s.name = 'Starting Intensity'; break;
                                    case 'intervalIntensity': s.name = 'Interval Intensity'; break;
                                    case 'intervalStepSize': s.name = 'Step Size'; break;
                                    case 'intervalDuration': s.name = 'Interval Duration'; break;

                                    case 'recoveryIntensity': s.name = 'Recovery Intensity'; break;
                                    case 'recoveryDuration': s.name = 'Recovery Duration'; break;

                                    case 'restingSettleInDuration': s.name = 'Time'; break;
                                    case 'restingMeasurementDuration': s.name = 'Time'; break;

                                    case 'step2StartingIntensity': s.name = '(2) Starting Intensity'; break;
                                    case 'step2Size': s.name = '(2) Step Size'; break;
                                    case 'step2InclineSize': s.name = '(2) Step Incline'; break;
                                    case 'step2StartingIncline': s.name = '(2) Starting Incline'; break;
                                    case 'step2Limit': s.name = '(2) Step Count'; break;

                                    case 'step3StartingIntensity': s.name = '(3) Starting Intensity'; break;
                                    case 'step3Size': s.name = '(3) Step Size'; break;
                                    case 'step3InclineSize': s.name = '(3) Step Incline'; break;
                                    case 'step3StartingIncline': s.name = '(3) Starting Incline'; break;
                                    case 'step3Limit': s.name = '(3) Step Count'; break;

                                    default:
                                        s.name = s.type;
                                        break;
                                }
                            });
                        }
                    });
                }
            } else {
                entity.protocolType = protocolTypes.Free;
                entity.protocolTypeName = protocolTypes.find(entity.protocolType).label;
            }
        }

        return entity
    }

});

const state = {
    ...baseEntity.state,
};
const getters = {
    ...baseEntity.getters,
};
const actions = {
    ...baseEntity.actions,
};
const mutations = {
    ...baseEntity.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};